export default "__VITE_ASSET__DxvHabFM__"